import React from 'react'
import Helmet from 'react-helmet'
import Offerings from '../Offerings'
import Testimonials from '../Testimonials'
import PropTypes from 'prop-types'

import Background from '../../../static/img/home.jpg'

const HomePageTemplate = (props) => {
  const { title, heading, description, offerings, meta_title, meta_description, testimonials } = props

  return (
    <div>
      <Helmet>
        <title>{meta_title}</title>
        <meta name='description' content={meta_description} />
      </Helmet>
      <section
        className='hero is-fullheight is-family-secondary'
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.7)), url(${Background})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',

        }}>
        <div className='hero-body'>
          <div className='container'>
            <br />
            <br />
            <h1 className='title has-text-white is-family-secondary'>
              HOME <br /><br /><br />Welcome to Food Fiction.
            </h1>
            <h2 className='subtitle has-text-white is-family-secondary'>
              Get a fix of your daily porn food fantasies!
            </h2>
          </div>
        </div>
      </section>
      <section className='section section--gradient'>
        <div className='container'>

          <div className='section'>
            <div className='columns'>
              <div className='column is-10 is-offset-1'>
                <div className='content'>
                  <div>
                    <h1 className='title is-family-secondary'>
                      {title}
                    </h1>
                    <h3 className='has-text-weight-semibold is-size-2 is-family-secondary'>
                      {heading}
                    </h3>
                    <p>{description}</p>
                  </div>
                  <Offerings gridItems={offerings.blurbs} />
                  <h2 className='has-text-weight-semibold is-size-2 is-family-secondary'>Testimonials</h2>
                  <Testimonials testimonials={testimonials} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
HomePageTemplate.propTypes = {
  title: PropTypes.string,
  meta_title: PropTypes.string,
  meta_description: PropTypes.string,
  heading: PropTypes.string,
  description: PropTypes.string,
  offerings: PropTypes.shape({
    blurbs: PropTypes.array,
  }),
  testimonials: PropTypes.array,

}

export default HomePageTemplate
